module.exports = __webpack_public_path__ + "img/emoji_flat.4651b51d.svg";